import type {
  DropdownGroup,
  DropdownOption,
} from "@freightsimple/ui-core/Controls/Dropdown";
import {
  descriptionForSortShipmentOption,
  SortShipmentOptions,
} from "@/Shared/Shipment/SortShipmentOptions";

// The sort dropdown's contents. Grouped the way the old sort dialog grouped
// them — the two ends of the lane, then the dates — so the eight options stay
// scannable.
const GROUPED: Array<{ group: string; options: SortShipmentOptions[] }> = [
  {
    group: "Pickup",
    options: [
      SortShipmentOptions.PickupBusinessName,
      SortShipmentOptions.PickupReferenceNumber,
    ],
  },
  {
    group: "Delivery",
    options: [
      SortShipmentOptions.DeliveryBusinessName,
      SortShipmentOptions.DeliveryReferenceNumber,
    ],
  },
  {
    group: "Dates",
    options: [
      SortShipmentOptions.BookingDate,
      SortShipmentOptions.PickupDate,
      SortShipmentOptions.EstimatedDeliveryDate,
      SortShipmentOptions.DeliveryDate,
    ],
  },
];

export const viewShipmentsSortGroups: DropdownGroup[] = GROUPED.map((g) => ({
  name: g.group,
}));

export const viewShipmentsSortOptions: DropdownOption[] = GROUPED.flatMap((g) =>
  g.options.map((option) => ({
    value: option,
    label: descriptionForSortShipmentOption(option),
    group: g.group,
  })),
);
